
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schools",
      function () {
        return require("private-next-pages/schools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schools"])
      });
    }
  